import {useContext, useState} from "react";
import styled from "styled-components";
import {sectionLayout, colors} from "../stylingVariables";
import {AppContext} from "../App";
import {Document, Page, pdfjs} from "react-pdf";
import {SectionHeadline} from "./SectionHeadline";
import {Button} from "./Button";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const StyledProducts = styled.section`
  ${sectionLayout};
`;

const StyledDocumentContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledDocument = styled.div`
`;

const StyledNavigation = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  grid-gap: 16px;
`;


const StyledCatalogItem = styled.a`
  margin-right: 30px;
  text-decoration: none;
  cursor: pointer;
  color: ${colors.white};

  &:hover {
    color: ${colors.lightgrey};
  }
`;

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

export const Products = () => {
  const { state, refs } = useContext(AppContext);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  return (
    <StyledProducts ref={refs.productSection}>
      <SectionHeadline index={1} />
      <StyledDocumentContainer>
        <StyledDocument>
          <Document file={state.products.catalog.file} onLoadSuccess={onDocumentLoadSuccess}>
            <Page pageNumber={pageNumber} />
          </Document>
          <StyledNavigation>
            <p>
              Seite {pageNumber || (numPages ? 1 : "--")} von {numPages || "--"}
            </p>
            <StyledButtonContainer>
              <Button onClick={previousPage} type={"button"} disabled={pageNumber <= 1}>Zurück</Button>
              <Button onClick={nextPage} type={"button"} disabled={pageNumber >= numPages}>Vor</Button>
            </StyledButtonContainer>
            <p>gültig bis {state.products.catalog.vaildUntil}</p>
            <p><StyledCatalogItem href={state.products.catalog.file}>Hier gibts das Frühlingsprospekt zum Download</StyledCatalogItem></p>
          </StyledNavigation>
        </StyledDocument>
      </StyledDocumentContainer>
    </StyledProducts>
  );
};